var _path, _path2, _path3, _path4, _ellipse, _ellipse2, _path5, _path6, _path7, _path8, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfileStudent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 91,
    viewBox: "0 0 82 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.4462 61.135L34.2583 49.1094L50.7687 50.74L53.3862 61.135L61.4401 64.3962L55.1983 73.3645L46.7418 80.906L35.4664 78.4601L23.5869 63.5809L32.4462 61.135Z",
    fill: "url(#paint0_linear_2573_2862)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.0477 76.6156L26.7131 65.0678L25.6999 62.2314C24.4841 62.7717 19.9045 64.8652 11.3126 68.9171C2.72073 72.9689 0.437663 85.3272 0.370117 90.9998H81.6282C81.6282 74.3061 72.577 66.7561 68.0514 65.0678L61.9723 63.8522L58.9327 65.0678C57.1089 66.7561 52.3672 71.4292 47.9902 76.6156C43.6132 81.8021 38.8715 78.7766 37.0477 76.6156Z",
    fill: "#B6D7E2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.1034 54.3904C32.4248 51.811 27.8955 42.2998 26.3407 37.8665L23.2986 39.4786L20.0537 36.456L21.4733 27.1865L24.921 25.1714L28.3687 20.5367L39.3202 21.7457L50.2717 17.3125L56.3559 17.7155L59.3979 27.9925L63.454 26.1789L64.4681 32.2243L63.454 37.8665H59.3979C56.9643 46.2494 51.7589 51.9722 49.4605 53.7858C48.0408 55.0621 43.7819 56.9697 38.1034 54.3904Z",
    fill: "#FEE7C6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M59.5422 37.8205C58.091 43.5067 53.1691 49.9798 50.6161 52.8229L50.6742 57.3951C50.6161 64.1887 52.1483 65.2944 59.5422 65.033C66.9361 64.7715 71.599 67.1029 71.599 67.1029C69.3147 60.6721 65.2261 45.1313 65.3873 31.322C65.5486 17.5126 62.7672 11.7504 61.5579 9.99882C58.3331 5.32802 51.7222 0.657227 43.0153 0.657227C32.1315 0.657227 27.2941 5.73418 24.6742 9.99882C21.2107 15.6366 19.0308 28.8851 18.023 41.679C17.572 47.4049 13.5889 62.4606 10.9688 69.2976C13.1186 68.0791 19.0308 65.5204 25.4804 65.033C31.93 64.5456 33.9455 60.9037 34.147 59.1437L34.9532 52.2391C30.9222 48.9898 27.4959 41.2728 26.2866 37.8205C25.2788 38.0913 23.1019 37.658 22.4569 33.7589C21.6507 28.8851 23.0616 27.8697 23.8678 27.6666C24.5127 27.5041 25.2114 29.2235 25.4802 30.1035C26.0848 26.8543 26.4879 26.6512 27.2941 24.6204C27.9391 22.9958 29.3096 22.5897 29.9143 22.5897C36.5251 24.5392 42.2089 22.9958 44.2244 21.9804C46.0383 21.0327 50.2709 19.0155 52.6895 18.5281C55.7127 17.9188 57.5267 23.402 57.7282 26.6512C57.8895 29.2506 58.736 30.8481 59.1391 31.322C59.3406 28.682 61.3561 27.6666 62.3639 28.0727C63.3716 28.4789 62.9685 29.6974 62.9685 33.5558C62.9685 36.6426 60.6843 37.6851 59.5422 37.8205Z",
    fill: "#1E1E38"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 35.1948,
    cy: 32.4544,
    rx: 1.51413,
    ry: 2.01883,
    fill: "#1C1C25"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 50.8413,
    cy: 32.4544,
    rx: 1.51413,
    ry: 2.01883,
    fill: "#1C1C25"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M48.8223 27.0583C49.9438 26.8839 52.5235 26.7096 53.8694 27.4071",
    stroke: "black",
    strokeWidth: 1.16571,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M44.2802 31.4443C44.2802 33.463 44.583 37.8635 45.7943 39.3169C45.578 40.0571 44.3667 41.4163 41.252 40.9318",
    stroke: "#C5A477",
    strokeWidth: 0.408,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M32.167 27.0583C33.2886 26.8839 35.8682 26.7096 37.2141 27.4071",
    stroke: "black",
    strokeWidth: 1.16571,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M45.2345 44.6965C43.2868 45.9733 40.9063 45.2285 39.9595 44.6965C38.8234 44.5369 38.6746 45.428 38.7422 45.8935C39.0127 46.6915 40.2841 48.2476 43.2057 48.088C46.8576 47.8885 47.0604 45.4945 46.6547 44.896C46.3301 44.4172 45.5726 44.5635 45.2345 44.6965Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2573_2862",
    x1: 42.5135,
    y1: 49.1094,
    x2: 42.5135,
    y2: 80.906,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8D3B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEE7C6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileStudent);
export default __webpack_public_path__ + "static/media/profile_student.a937468c9ae67ff8a849b7bbc574656f.svg";
export { ForwardRef as ReactComponent };